export const capitalizeWord = (stringToCapitalize: string | undefined | null) => {
  if (!stringToCapitalize) return '';
  return stringToCapitalize.charAt(0).toUpperCase() + stringToCapitalize.slice(1).toLowerCase();
};

export default capitalizeWord;
